import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { Layout } from '@/app/types/app/common'

import LayoutDefault from '@/layouts/LayoutDefault.vue'
import LayoutEmpty from '@/layouts/LayoutEmpty.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()

const layoutName = computed(() => route.meta?.layout)

const layout = computed(() => {
  switch (layoutName.value) {
    case Layout.Default:
      return LayoutDefault
    case Layout.Empty:
      return LayoutEmpty
    default:
      return LayoutDefault
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (layoutName.value === layout.value.name)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})